import { ua, isiOS, isAndroid, geolocKey } from './consts'
import axios from 'axios'

class Spy {
  constructor () {
    if ( !window.WURFL ) return console.error( 'WURFL must be loaded before creating an instance of Spy!' )

    this.device = window.WURFL.is_mobile ? this.getDeviceMobile() : this.getDeviceDesktop()
    this.browser = this.getBrowser()
  }

  getDeviceMobile () {
    let name = window.WURFL.complete_device_name

    switch ( true ) {
      case (!!name.match( /(?:microsoft|apple)/i )):
        return name.match( /(?:microsoft|apple)(.+)/i )[ 1 ].trim()

      default:
        return name.match( /\(([^)]+)\)/ )[ 1 ].trim()
    }
  }

  getDeviceDesktop () {
    let name = window.navigator.platform.match( /(mac|win|linux)/i )

    if ( !name ) return 'Desktop Computer'

    switch ( name[ 0 ] ) {
      case 'Linux':
        return 'Machine running Linux'
      case 'Win':
        return 'Windows computer'
      case 'Mac':
        return 'Mac'
    }
  }

  getBrowser () {
    switch ( true ) {
      case ( ( /Chrome/.test( ua ) && /Google Inc/.test( window.navigator.vendor ) ) || /CriOS/.test( ua ) ):
        return isiOS ? 'Chrome for iOS' : isAndroid ? 'Chrome for Android' : 'Google Chrome'

      case (/Safari/.test( ua ) && !ua.includes( 'Chrome' )):
        return 'Safari'

      case (/rv:\S*\s(?!like\s)Gecko/.test( ua )):
        return isiOS ? 'Firefox for iOS' : isAndroid ? 'Firefox for Android' : 'Firefox'

      case (/Windows.*Edge/.test( ua )):
        return isiOS ? 'Microsoft Edge for iOS' : isAndroid ? 'Microsoft Edge for Android' : 'Microsoft Edge'

      case (/(?:Trident.*rv:11\.|MSIE )/.test( ua )):
        return 'Internet Explorer'

      default:
        return 'Mystery Browser'
    }
  }

  get location () {
    return this.getLocation()
  }

  getLocation (latlngParam = '') {
    let catchErr = err => {
      console.error( err )
      return 'Unknown'
    }

    return axios( {
      method: 'post',
      url: 'https://www.googleapis.com/geolocation/v1/geolocate',
      params: {
        key: geolocKey
      },
      data: {}
    } ).then( resp => {
      let latlng = latlngParam || Object.values( resp.data.location ).join( ',' )

      return axios.get( 'https://maps.googleapis.com/maps/api/geocode/json', {
        params: {
          latlng: latlng,
          key: geolocKey
        }
      } ).then( resp => {
        let targetSet = resp.data.results.find( obj => obj.types.includes( 'postal_code' ) )
        if (typeof targetSet !== 'undefined') {
          let city = targetSet.address_components.find( obj => obj.types.includes( 'sublocality' ) || obj.types.includes( 'locality' ) ).long_name
          let state = targetSet.address_components.find( obj => obj.types.includes( 'administrative_area_level_1' ) ).long_name
          return [city, state].join(', ')
        }
        return 'Unknown'
      } ).catch( catchErr )
    } ).catch( catchErr )
  }
}

export default Spy



// WEBPACK FOOTER //
// ./src/lib/Spy.js